import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AdminAuthService } from './admin-auth.service';

@Injectable()
export class AdminAuthGuard  {

  constructor(
    private router: Router,
    private adminAuth: AdminAuthService,
  ) { }

  canActivate() {
    if (this.adminAuth.adminLoggedIn()) {
    // if (true) {
      return true;
    } else {
      this.router.navigate(['/login-admin']);
    }
  }

}
